import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from '../ai/AppInsights';
import { types } from '../actions/timesheetActions';

const initialState = {
  pendingFlag: false,
  error: '',
  response: '',
  timesheetsByDate: [
    {
      date: '26/09/2022',
      entriesTime: [
        {
          type: '',
          location: '',
          time: ''
        }
      ]
    }
  ]
};

export default function timesheet(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TIMESHEET_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        error: '',
        response: action.payload?.Data
      };
    case types.FETCH_TIMESHEET_PENDING:
      return { ...state, pendingFlag: true, error: '' };
    case types.FETCH_TIMESHEET_REJECTED:
      appInsights.trackException({
        error: new Error(action.payload.message),
        severityLevel: SeverityLevel.Error
      });
      return { ...state, pendingFlag: false, error: action.payload.message };
    case 'ADD':
      return {
        ...state,
        timesheetsByDate: state.timesheetsByDate.map((date) =>
          date.date !== action.payload
            ? date
            : {
                ...date,
                entriesTime: [
                  ...date.entriesTime,
                  {
                    type: '',
                    location: '',
                    time: ''
                  }
                ]
              }
        )
      };
    case 'DELETE':
      return {
        ...state,
        timesheetsByDate: state.timesheetsByDate.map((date) =>
          date.date !== action.payload.date
            ? date
            : date.entriesTime.filter((_, index) => index === action.payload.index)
        )
      };
    default:
      return state;
  }
}
